/**
 * @generated SignedSource<<b080b5d05dcaa97f205524b6515ddd9a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type VerifyAndAssignEmailInput = {
  code: string;
  email: string;
};
export type useVerifyAndAssignEmailCodeNotificationsMutation$variables = {
  input: VerifyAndAssignEmailInput;
};
export type useVerifyAndAssignEmailCodeNotificationsMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly success: boolean;
    readonly user: {
      readonly email: string | null | undefined;
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly phoneNumber: {
        readonly nationalNumber: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useVerifyAndAssignEmailCodeNotificationsMutation = {
  response: useVerifyAndAssignEmailCodeNotificationsMutation$data;
  variables: useVerifyAndAssignEmailCodeNotificationsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nationalNumber",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useVerifyAndAssignEmailCodeNotificationsMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "VerifyAndAssignEmailPayload",
        "kind": "LinkedField",
        "name": "verifyAndAssignEmail",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberUser",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PhoneNumber",
                "kind": "LinkedField",
                "name": "phoneNumber",
                "plural": false,
                "selections": [
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useVerifyAndAssignEmailCodeNotificationsMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "VerifyAndAssignEmailPayload",
        "kind": "LinkedField",
        "name": "verifyAndAssignEmail",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberUser",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PhoneNumber",
                "kind": "LinkedField",
                "name": "phoneNumber",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "01d91fa2be98faf2ba776dfd342786bc",
    "id": null,
    "metadata": {},
    "name": "useVerifyAndAssignEmailCodeNotificationsMutation",
    "operationKind": "mutation",
    "text": "mutation useVerifyAndAssignEmailCodeNotificationsMutation(\n  $input: VerifyAndAssignEmailInput!\n) {\n  responsePayload: verifyAndAssignEmail(input: $input) {\n    success\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n    user {\n      id\n      email\n      firstName\n      lastName\n      phoneNumber {\n        nationalNumber\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f2ebc3b09e669e5132078785c5c6a8f3";

export default node;
